// Faixa de prontidao (topo da ficha) — Fotos / Descricao / SEO / Grade,
// cada um com check (--good-soft) ou alerta (--warn-soft) e tooltip do que
// falta. Fonte unica: lib/readiness.ts (mesma usada pelo rodape de publicar).
import { AlertTriangle, Check } from "lucide-react";
import type { ReadinessChip } from "../../lib/readiness";

export function ReadinessBar({ chips }: { chips: ReadinessChip[] }): JSX.Element {
  return (
    <>
      {chips.map((c) => (
        <span
          key={c.key}
          title={c.hint}
          className="chip"
          style={{
            background: c.ok ? "var(--color-good-soft)" : "var(--color-warn-soft)",
            color: c.ok ? "var(--color-good)" : "var(--color-warn)",
          }}
        >
          {c.ok ? <Check className="icon" style={{ width: "0.875em", height: "0.875em" }} aria-hidden /> : <AlertTriangle className="icon" style={{ width: "0.875em", height: "0.875em" }} aria-hidden />}
          {c.label}
        </span>
      ))}
    </>
  );
}
